let context = {
   popupOpen: false,
   conversationId: null,
};

const listeners = new Set();

function emit() {
   listeners.forEach((cb) => {
      try {
         cb();
      } catch {}
   });
}

export function getChatToastContext() {
   return context;
}

export function setChatToastContext(partial) {
   context = { ...context, ...partial };
   emit();
}

export function subscribeChatToastContext(cb) {
   listeners.add(cb);
   return () => listeners.delete(cb);
}
